import { EMAIL_CAMPAIGN_CONST } from "./emailCampaignConstants";

// Location list for filter dropdown
const emailCampaignLocations = [
  {
    id: 1,
    name: "3151 - Domino's, Doral, FL",
    address: "Doral, FL",
  },
  {
    id: 2,
    name: "3812 - Domino's, Miami, FL",
    address: "Miami, FL",
  },
  {
    id: 3,
    name: "5177 - Domino's, Miami, FL",
    address: "Miami, FL",
  },
];

const emailCampaigns = [
  {
    id: 1,
    name: "Late Night Sales",
    templates: EMAIL_CAMPAIGN_CONST.TEMPLATES,
    locations: emailCampaignLocations,
    description: "Email Campaign 1 Description",
    status: "Active",
    createdAt: "2021-01-01",
    updatedAt: "2021-01-01",
    createdBy: "John Doe",
    updatedBy: "Jane Doe",
    createdByRole: "Admin",
  },

  {
    id: 2,
    name: "Customer Appreciation",
    templates: EMAIL_CAMPAIGN_CONST.TEMPLATES,
    locations: emailCampaignLocations,
    description: "Email Campaign 1 Description",
    status: "Active",
    createdAt: "2021-01-01",
    updatedAt: "2021-01-01",
    createdBy: "John Doe",
    updatedBy: "Jane Doe",
    createdByRole: "Admin",
  },
  {
    id: 3,
    name: "Grand Opening",
    templates: EMAIL_CAMPAIGN_CONST.TEMPLATES,
    locations: emailCampaignLocations,
    description: "Email Campaign 1 Description",
    status: "Active",
    createdAt: "2021-01-01",
    updatedAt: "2021-01-01",
    createdBy: "John Doe",
    updatedBy: "Jane Doe",
    createdByRole: "Admin",
  },
];

const emailCampaignReportData = [
  {
    id: 1,
    name: "Customer Appreciation",
    status: "Scheduled",
    delivered: "-",
    unique_opens: "-",
    unique_clicks: "-",
  },
  {
    id: 2,
    name: "Late Night",
    status: "Sent",
    delivered: "4,439",
    unique_opens: "2,422",
    unique_clicks: "168",
  },
  {
    id: 3,
    name: "Grand Opening",
    status: "Sent",
    delivered: "1,257",
    unique_opens: "724",
    unique_clicks: "49",
  },
];

// Location-wise Email Campaign Report Data
const locationWiseEmailCampaignReportData = {
  "3151 - Domino's, Doral, FL": {
    locationId: "3151",
    locationName: "3151 - Domino's",
    locationAddress: "Doral, FL",
    summary: {
      emailsSent: 5325,
      delivered: 4439,
      uniqueOpens: 2422,
      uniqueClicks: 168,
      conversions: 27,
      bounces: 324,
    },
    campaigns: [
      {
        id: 1,
        locationName: "3151 - Domino's",
        sendDate: "7/18/25",
        status: "Sent",
        customerList: "Frequent Late-Night Orderers (1,944 contacts)",
        template: "50% Off",
        emailsSent: 1944,
        delivered: 1653,
        uniqueOpens: 810,
        conversions: 9,
        bounces: 123,
        image: "/img/email-campaign/50off.png",
      },
      {
        id: 2,
        locationName: "3151 - Domino's",
        sendDate: "7/4/25",
        status: "Sent",
        customerList: "Late-Night High Value Customers (1,238 contacts)",
        template: "Free Small Pizza",
        emailsSent: 1238,
        delivered: 1077,
        uniqueOpens: 581,
        conversions: 7,
        bounces: 98,
        image: "/img/email-campaign/free.png",
      },
      {
        id: 3,
        locationName: "3151 - Domino's",
        sendDate: "6/20/25",
        status: "Sent",
        customerList: "Frequent Late-Night Orderers (2,143 contacts)",
        template: "50% Off",
        emailsSent: 2143,
        delivered: 1709,
        uniqueOpens: 1031,
        conversions: 11,
        bounces: 103,
        image: "/img/email-campaign/50off.png",
      },
    ],
  },
  "3812 - Domino's, Miami, FL": {
    locationId: "3812",
    locationName: "3812 - Domino's",
    locationAddress: "Miami, FL",
    summary: {
      emailsSent: 4120,
      delivered: 3456,
      uniqueOpens: 1890,
      uniqueClicks: 142,
      conversions: 23,
      bounces: 289,
    },
    campaigns: [
      {
        id: 4,
        locationName: "3812 - Domino's",
        sendDate: "7/15/25",
        status: "Sent",
        customerList: "Weekend Warriors (1,567 contacts)",
        template: "Buy One Get One Free",
        emailsSent: 1567,
        delivered: 1345,
        uniqueOpens: 678,
        conversions: 12,
        bounces: 89,
        image: "/img/email-campaign/50off.png",
      },
      {
        id: 5,
        locationName: "3812 - Domino's",
        sendDate: "7/1/25",
        status: "Sent",
        customerList: "Loyal Customers (1,234 contacts)",
        template: "25% Off Everything",
        emailsSent: 1234,
        delivered: 1089,
        uniqueOpens: 543,
        conversions: 8,
        bounces: 76,
        image: "/img/email-campaign/50off.png",
      },
      {
        id: 6,
        locationName: "3812 - Domino's",
        sendDate: "6/18/25",
        status: "Sent",
        customerList: "New Customer Welcome (1,319 contacts)",
        template: "Welcome 20% Off",
        emailsSent: 1319,
        delivered: 1022,
        uniqueOpens: 669,
        conversions: 3,
        bounces: 124,
        image: "/img/email-campaign/50off.png",
      },
    ],
  },
  "5177 - Domino's, Miami, FL": {
    locationId: "5177",
    locationName: "5177 - Domino's",
    locationAddress: "Miami, FL",
    summary: {
      emailsSent: 3890,
      delivered: 3215,
      uniqueOpens: 1654,
      uniqueClicks: 98,
      conversions: 19,
      bounces: 245,
    },
    campaigns: [
      {
        id: 7,
        locationName: "5177 - Domino's",
        sendDate: "7/12/25",
        status: "Sent",
        customerList: "Lunch Special Lovers (1,445 contacts)",
        template: "Lunch Combo Deal",
        emailsSent: 1445,
        delivered: 1234,
        uniqueOpens: 567,
        conversions: 6,
        bounces: 78,
        image: "/img/email-campaign/50off.png",
      },
      {
        id: 8,
        locationName: "5177 - Domino's",
        sendDate: "6/28/25",
        status: "Sent",
        customerList: "Family Meal Buyers (1,234 contacts)",
        template: "Family Bundle Discount",
        emailsSent: 1234,
        delivered: 987,
        uniqueOpens: 445,
        conversions: 5,
        bounces: 67,
        image: "/img/email-campaign/50off.png",
      },
      {
        id: 9,
        locationName: "5177 - Domino's",
        sendDate: "6/15/25",
        status: "Sent",
        customerList: "Weekend Special Customers (1,211 contacts)",
        template: "Weekend Special",
        emailsSent: 1211,
        delivered: 994,
        uniqueOpens: 642,
        conversions: 8,
        bounces: 100,
        image: "/img/email-campaign/50off.png",
      },
    ],
  },
  "6245 - Domino's": {
    locationId: "6245",
    locationName: "6245 - Domino's",
    locationAddress: "Coral Gables, FL",
    summary: {
      emailsSent: 4560,
      delivered: 3890,
      uniqueOpens: 2100,
      uniqueClicks: 185,
      conversions: 31,
      bounces: 298,
    },
    campaigns: [
      {
        id: 10,
        locationName: "6245 - Domino's",
        sendDate: "7/20/25",
        status: "Sent",
        customerList: "Premium Customers (1,678 contacts)",
        template: "Premium Member Exclusive",
        emailsSent: 1678,
        delivered: 1456,
        uniqueOpens: 789,
        conversions: 15,
        bounces: 112,
        image: "/img/email-campaign/50off.png",
      },
      {
        id: 11,
        locationName: "6245 - Domino's",
        sendDate: "7/6/25",
        status: "Sent",
        customerList: "Student Discount Members (1,345 contacts)",
        template: "Student Special",
        emailsSent: 1345,
        delivered: 1156,
        uniqueOpens: 623,
        conversions: 9,
        bounces: 89,
        image: "/img/email-campaign/50off.png",
      },
      {
        id: 12,
        locationName: "6245 - Domino's",
        sendDate: "6/22/25",
        status: "Sent",
        customerList: "Corporate Lunch Orders (1,537 contacts)",
        template: "Corporate Lunch Deal",
        emailsSent: 1537,
        delivered: 1278,
        uniqueOpens: 688,
        conversions: 7,
        bounces: 97,
        image: "/img/email-campaign/50off.png",
      },
    ],
  },
  "7890 - Domino's": {
    locationId: "7890",
    locationName: "7890 - Domino's",
    locationAddress: "Brickell, FL",
    summary: {
      emailsSent: 5230,
      delivered: 4456,
      uniqueOpens: 2345,
      uniqueClicks: 198,
      conversions: 35,
      bounces: 312,
    },
    campaigns: [
      {
        id: 13,
        locationName: "7890 - Domino's",
        sendDate: "7/22/25",
        status: "Sent",
        customerList: "Downtown Office Workers (1,890 contacts)",
        template: "Office Lunch Special",
        emailsSent: 1890,
        delivered: 1654,
        uniqueOpens: 856,
        conversions: 18,
        bounces: 134,
        image: "/img/email-campaign/50off.png",
      },
      {
        id: 14,
        locationName: "7890 - Domino's",
        sendDate: "7/8/25",
        status: "Sent",
        customerList: "Late Night Downtown Crowd (1,567 contacts)",
        template: "Late Night Special",
        emailsSent: 1567,
        delivered: 1345,
        uniqueOpens: 678,
        conversions: 12,
        bounces: 98,
        image: "/img/email-campaign/50off.png",
      },
      {
        id: 15,
        locationName: "7890 - Domino's",
        sendDate: "6/25/25",
        status: "Sent",
        customerList: "Weekend Party Planners (1,773 contacts)",
        template: "Party Pack Discount",
        emailsSent: 1773,
        delivered: 1457,
        uniqueOpens: 811,
        conversions: 5,
        bounces: 80,
        image: "/img/email-campaign/50off.png",
      },
    ],
  },
};

export {
  emailCampaigns,
  emailCampaignReportData,
  locationWiseEmailCampaignReportData,
  emailCampaignLocations,
};
